import { Outlet } from 'react-router-dom';
import { Container } from '@mui/material';
import useOrganizations from '../useOrganizations';
import { Organization } from '@/types';
import { useAppSelector } from '@/hooks';

export interface OrganizationContext {
  organizations: Record<Organization['id'], Organization>;
  currentOrganization: Organization;
}

const OrganizationLayout = () => {
  const { organizations, currentOrganization } = useOrganizations();
  const container = useAppSelector((state) => state.ui?.container);

  return (
    <Container
      maxWidth={container === 'fixed' ? 'lg' : false}
      sx={{
        height: '100%',
      }}
    >
      <Outlet context={{ currentOrganization, organizations }} />
    </Container>
  );
};

export default OrganizationLayout;
